import { render, staticRenderFns } from "./Crosswalk.vue?vue&type=template&id=03bfe6ce"
import script from "./Crosswalk.vue?vue&type=script&lang=js"
export * from "./Crosswalk.vue?vue&type=script&lang=js"
import style0 from "./Crosswalk.vue?vue&type=style&index=0&id=03bfe6ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports